import { create } from "zustand";
import { persist } from "zustand/middleware";
import { todayBucharestIso } from "../lib/intervals";

interface PositionFilterState {
  deliveryDate: string;
  portfolioDa: string;
  portfolioId: string;
  setDeliveryDate(date: string): void;
  setPortfolioDa(id: string): void;
  setPortfolioId(id: string): void;
  clear(): void;
}

export const usePositionFilter = create<PositionFilterState>()(
  persist(
    (set) => ({
      deliveryDate: todayBucharestIso(),
      portfolioDa: "",
      portfolioId: "",
      setDeliveryDate: (deliveryDate) => set({ deliveryDate }),
      setPortfolioDa: (portfolioDa) => set({ portfolioDa }),
      setPortfolioId: (portfolioId) => set({ portfolioId }),
      clear: () => set({ deliveryDate: todayBucharestIso(), portfolioDa: "", portfolioId: "" }),
    }),
    {
      name: "chro-position-filter",
      merge: (persisted, current) => ({
        ...current,
        ...(persisted as Partial<PositionFilterState>),
        deliveryDate:
          (persisted as Partial<PositionFilterState> | undefined)?.deliveryDate ??
          current.deliveryDate,
      }),
    }
  )
);
